import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import axios from 'axios';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


export const HomeDetailPanel = () => {
  const [HomeDetail, setHomeDetail] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const response = await axios.get(
        "https://cyberathon.com/silverapartment/index.php/Api/Silver_Controller/home_details_list"
      );
      setHomeDetail([response.data.data]);
    };

    fetchData();
  }, []);

  return (
    <div className="container mt-5">
      <h2 className="mb-4">Home Details</h2>

      {HomeDetail.map((Data, index) => (
        <div key={index} className="border rounded p-4 mb-4 shadow-sm bg-light">
          <div className="d-flex justify-content-end">
            <Link to={`/Master/HomeDetail-edit/${Data.web_id}`}>
              <button className="btn btn-primary btn-sm me-2">
               <i className="fa-regular fa-pen-to-square text-white" /> Edit
              </button>
            </Link>
          </div>
          <img src={`https://cyberathon.com/silverapartment/${Data.logo_img}`} width={300}/>
          <br/>
          <br/>
          <p>{Data.web_title}</p>
          <p>{Data.wed_subtitle}</p>
        </div>
      ))}
    </div>
  );
};


export const EditHomeDetail = () => {
  const [Logo, setLogo] = useState(null);
  const [HomeDetailUser, setHomeDetailUser] = useState({
    web_title: "",
    wed_subtitle: "",
  });

  const { id } = useParams();
  const navigate = useNavigate();

  const changeHandler = (e) => {
    const { name, value } = e.target;
    setHomeDetailUser((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  useEffect(() => {
    const HomeDetailInfoData = async () => {
      try {
        const response = await axios.post(
          `https://cyberathon.com/silverapartment/index.php/Api/Silver_Controller/get_home_details_by_id`,
          {
            web_id: id,
          }
        );
        setHomeDetailUser(response.data.data);
      } catch (error) {
        console.error("There was an error!", error);
      }
    };
    HomeDetailInfoData();
  }, [id]);

  const submitForm = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("web_id", id);
    formData.append("web_title", HomeDetailUser.web_title);
    formData.append("wed_subtitle", HomeDetailUser.wed_subtitle);

    if (Logo) {
      formData.append("logo_img", Logo);
    }

    try {
      const response = await axios.post(
        `https://cyberathon.com/silverapartment/index.php/Api/Silver_Controller/update_home_details`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      if (response.data.success === "1") {
        toast.info(response.data.message || "Data updated successfully");
        navigate("/Master/HomeDetail");
      } else {
        toast.error(response.data.message || "Failed to update Near Point");
      }
    } catch (error) {
      console.error("There was an error!", error);
    }
  };

  return (
    <div
      className="modal fade show"
      id="update_heading"
      tabIndex={-1}
      role="dialog"
      style={{
        display: "block",
        paddingRight: 18,
        marginTop: 90,
        paddingBottom: 50,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
      }}
      aria-modal="true"
    >
      <div className="modal-dialog">
        <form onSubmit={submitForm}>
          <div className="modal-content">
            {/* Modal Header */}
            <div className="modal-header bg-primary text-white">
              <h5 className="modal-title">Edit Home Detail</h5>
              <Link to="/Master/HomeDetail">
                <button
                  type="button"
                  className="btn-close btn-close-white"
                  aria-label="Close"
                ></button>
              </Link>
            </div>

            {/* Modal Body */}
            <div className="modal-body">
                         <div className="mb-3">
                <label className="form-label">
                  Logo{" "}
                  <span className="text-danger">
                    (Image must be at least 90x100%)
                  </span>
                </label>
                <input
                  type="file"
                  className="form-control"
                  id="logo_img"
                  onChange={(e) => setLogo(e.target.files[0])}
                />
              </div>

              <div className="mb-3">
                <label className="form-label">Title</label>
                <input
                  type="text"
                  value={HomeDetailUser.web_title}
                  onChange={changeHandler}
                  className="form-control"
                  name="web_title"
                  id="web_title"
                />
              </div>

              <div className="mb-3">
                <label className="form-label">Sub Title</label>
                <input
                  type="text"
                  value={HomeDetailUser.wed_subtitle}
                  onChange={changeHandler}
                  className="form-control"
                  name="wed_subtitle"
                  id="wed_subtitle"
                />
              </div>
            </div>

            {/* Modal Footer */}
            <div className="modal-footer">
              <Link to="/Master/HomeDetail">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                >
                  Close
                </button>
              </Link>
              <button type="submit" className="btn btn-success">
                Update
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};